import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";

export const PipelinesLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListPipelines') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreatePipeline') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/pipelines'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetPipeline') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/pipelines'/>
                    )
                }

            >
            </Route>


        </Routes>
    );
};
